export default __webpack_public_path__ + "media/color/etp-97cc8dbf.svg";